import { createApp } from 'vue';
import ClickoutPrivateLeasePage from './clickoutPrivateleasePage.vue';
import Mixins from '../../vue-elements/comparison-lib/mixins';
import docReady from '../../../assets/js/docReady';

docReady(() => {
    const component = document.getElementById('private-lease-clickout');
    if (!component) {
        return;
    }

    const productData = JSON.parse(localStorage.getItem('privateLeaseProductData'));

    const clickOutModule = createApp(ClickoutPrivateLeasePage, { product: productData });

    clickOutModule.mixin(Mixins());
    clickOutModule.mount(component);
});
